import React, { FC } from 'react'

import styled from 'styled-components'

const StyledSvg = styled.svg`
  display: inline-block;
  vertical-align: -4px;
  margin: 0;
  ${(props) => props.theme.marginLeft}: -34px;
  ${(props) => props.theme.marginRight}: 10px;
`

export const GiftPlusSvg: FC<{ size?: number }> = ({ size = 24 }) => (
  <StyledSvg width={size} height={size} viewBox="0 0 24 24">
    <defs>
      <linearGradient
        id="kwq80msxma"
        x1="15.85%"
        x2="100%"
        y1="-38.877%"
        y2="146.162%"
      >
        <stop offset="0%" stopColor="#FCB592" />
        <stop offset="100%" stopColor="#F77E59" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g transform="translate(-372 -1312) translate(372 1312)">
          <circle cx="12" cy="12" r="12" fill="url(#kwq80msxma)" />
          <g
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path d="M0 0.5L12 0.5" transform="translate(6 11.5)" />
          </g>
          <g
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path d="M0 0.5L12 0.5" transform="rotate(-90 14.75 3.25)" />
          </g>
        </g>
      </g>
    </g>
  </StyledSvg>
)
